// tslint:disable
export var EligibilityScope;
(function (EligibilityScope) {
    // All
    EligibilityScope[EligibilityScope["All"] = 4294967295] = "All";
    // Survey
    EligibilityScope[EligibilityScope["Survey"] = 1] = "Survey";
    // Patient
    EligibilityScope[EligibilityScope["Patient"] = 2] = "Patient";
    // Income
    EligibilityScope[EligibilityScope["Income"] = 4] = "Income";
})(EligibilityScope || (EligibilityScope = {}));
EligibilityScope['ALL'] = 4294967295;
EligibilityScope['SURVEY'] = 1;
EligibilityScope['PATIENT'] = 2;
EligibilityScope['INCOME'] = 4;
//# sourceMappingURL=EligibilityScope.js.map